const SectionHero = () => {
  return (
    <div className="w-full h-full flex justify-center mt-16 md:mt-20 relative">
      <video
        muted
        playsInline
        controls={false}
        autoPlay
        loop
        style={{ marginTop: 0, width: '100%', height: '100%', display: 'flex' }}
      >
        <source src='/videos/loop-hero.webm' type="video/webm" />
      </video>
      <div
        style={{
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          display: 'flex',
          position: 'absolute',
          backgroundColor: 'rgba(0,0,0,0.5)',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            color: 'white',
            lineHeight: '1.2',
            fontSize: 'var(--text-hero)',
            fontWeight: 'bold',
          }}
        >
          자율주행 기술과 함께하는
        </div>

        <div
          style={{
            color: 'white',
            lineHeight: '1.2',
            fontSize: 'var(--text-hero)',
            fontWeight: 'bold',
          }}
        >
          일상을 만드는 기업 CLABIL
        </div>
      </div>
    </div>
  )
}

export default SectionHero;